package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.EncodeDefault
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SubjectCreateRequest(
    val name: String,
    @SerialName("short_code")
    val shortCode: String,
    val category: String? = null,
    @EncodeDefault
    @SerialName("is_active")
    val isActive: Boolean = true
)

@Serializable
data class SubjectUpdateRequest(
    @SerialName("school_id")
    val schoolId: String? = null,
    val name: String? = null,
    @SerialName("short_code")
    val shortCode: String? = null,
    val category: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null
)

@Serializable
data class SubjectFilterRequest(
    @SerialName("subjectCode")
    val subjectCode: String? = null,
    @SerialName("subjectName")
    val subjectName: String? = null,
    val category: String? = null,
    val status: String? = null,
    @SerialName("createdDateFrom")
    val createdDateFrom: String? = null,
    @SerialName("createdDateTo")
    val createdDateTo: String? = null
)
